module.exports = __webpack_public_path__ + "assets/5a6f9a7cfb0e7283535011e0cbffbfb7.png";